// src/components/sections/Rewards.jsx
import React from 'react';
import Button from '../ui/button';

const Rewards = () => {
  return (
    <section className="rewards" id="rewards">
      <div className="container rewards-container scale-in">
        
        {/* Left Column: Rewards Main */}
        <div className="rewards-main">
          <div className="rewards-header">
            <h2>Your Kinetix Rewards</h2>
            <p className="subtitle" style={{ color: 'var(--text-secondary)' }}>
              Earn SOL rewards by trading and referring new users.
            </p>
          </div>

          <div className="sol-received">
            <h3>5.28 SOL</h3>
            <p>Total Rewards Received to Date</p>
            <Button variant="primary" style={{ marginTop: '15px' }}>Claim Rewards</Button>
          </div>

          <div className="progress-section">
            <h3>Weekly Volume Progress</h3>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: '65%' }}></div>
            </div>
            <div className="progress-text">
              <span>$6,500 / $10,000 Volume Goal</span>
              <span>65% Complete</span>
            </div>
          </div>

          <div className="work-stats">
            <div className="stat-card">
              <h4>Total Trading Volume</h4>
              <p>$185,450</p>
            </div>
            <div className="stat-card">
              <h4>Referrals Paid Out</h4>
              <p>2.1 SOL</p>
            </div>
          </div>
        </div>
        
        {/* Right Column: Referrals */}
        <div className="referrals slide-in-right">
          <h3>Referral Program Tiers</h3>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
            Invite friends to earn a percentage of their trading fees, forever.
          </p>

          <div className="referral-levels">
            <div className="referral-level">
              <div className="level-info">
                <div className="level-amount">15% Commission</div>
                <div className="level-percent">Level 1 Friends</div>
              </div>
              <div className="level-badge">L1</div>
            </div>
            <div className="referral-level">
              <div className="level-info">
                <div className="level-amount">5% Commission</div>
                <div className="level-percent">Level 2 Friends</div>
              </div>
              <div className="level-badge">L2</div>
            </div>
          </div>

          <div className="active-write">
            <p>Your referral link is active. Share it widely!</p>
            <Button variant="primary" style={{ width: '100%', marginTop: '15px' }}>
              Copy Referral Link
            </Button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Rewards;